var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 666.667,
    viewBox: "0 0 1000 666.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001 0h749.162v499.807H.001z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 463h666V11H39z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath54",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 463h666V11H39z"
  })), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath54)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(666 0 0 452 39 11)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    imageRendering: "optimizeSpeed",
    preserveAspectRatio: "none",
    transform: "matrix(1 0 0 -1 0 1)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("mask", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    imageRendering: "optimizeSpeed",
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath134",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath186",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.214 246.171h92.13v-92.133h-92.13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath202",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.197 246.203h113.66v-92.155h-113.66z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath218",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.185 204.099h51.8v-49.981h-51.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath236",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.646 188.743h163.89v18.092h-163.89z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath264",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath364",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.872 289.956a5.396 5.396 0 019.776-4.571 5.397 5.397 0 01-2.603 7.174 5.397 5.397 0 01-7.173-2.603"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath380",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath492",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.224 209.185a5.458 5.458 0 018.445-6.914 5.457 5.457 0 01-.765 7.679 5.432 5.432 0 01-3.454 1.236 5.45 5.45 0 01-4.226-2.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath508",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath726",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.7 162.471l-9.873-25.516h22.408l-9.872 25.516a1.407 1.407 0 01-1.332.912 1.405 1.405 0 01-1.331-.912"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath738",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath752",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.057 162.391l-9.873-25.515h22.408l-9.874 25.515a1.404 1.404 0 01-1.33.913 1.404 1.404 0 01-1.331-.913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath764",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 500h750V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 666.667)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    fontFamily: "Ubuntu",
    fontSize: 7.561,
    fontStretch: "normal",
    fontVariant: "normal",
    fontWeight: "bold",
    transform: "matrix(1 0 0 -1 125.476 168.52)",
    writingMode: "lr-tb"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 6.7823067 12.755576 17.79883 22.380856 24.19552 26.584827 32.301018 36.579845",
    y: 0
  }, "\n            MORE INFO\n          ")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath134)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(648.225 196.331)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c3.726 12.073 4.596 24.92 1.925 37.27-4.179 19.319-17.638 42.707-56.48 52.8-73.534 19.107-99.066 74.983-167.851 57.188 0 0-36.914-6.708-54.385-67.788-17.47-61.081-85.924-62.12-62.355-115.304 3.853-8.693 14.226-18.176 29.119-27.133l278.949.938C-11.801-38.852-5.801-18.802 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.404 240.012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6d7f4",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-10.466v11.449c0 5.748-4.004 10.55-9.371 11.797v14.21h-3.852v-13.94c-6.178-.557-11.022-5.743-11.022-12.067V-.336h-10.411v-13.133h-.701v-24.407l-18.924.136v29.171H-86.43v-21.378h-15.214v-20.768h-18.386v-54.972h61.086v.008h13.121v-.008h76.597v69.322H-.027z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.444 209.799)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6d7f4",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v27.327h10.245v14.616h3.851V27.327h9.438V0h10.59v-16.372H51v55.771h35.232V-75.474h-99.264V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558.93 134.603)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3d5ac4",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-160.582-.126c-6.082-.005-11.017 4.922-11.022 11.004l182.608.143C11.009 4.938 6.082.004 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(558.927 138.394)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-160.582-.125c-4.748-.004-8.784 3.003-10.334 7.213l-.685-.001c.005-6.082 4.94-11.009 11.022-11.004L.003-3.791c6.082.004 11.009 4.938 11.004 11.02h-.685C8.779 3.017 4.747.004 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.007 141.874)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27429c",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-20.747-.016a3.687 3.687 0 00-3.69 3.684l28.121.021A3.687 3.687 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.536 145.617)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-163.812-.129-.078 98.876c-.004 5.672 4.591 10.274 10.263 10.278l143.271.112c5.672.005 10.274-4.59 10.279-10.262z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.998 154.152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#312c76",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-146.75-.115-.072 92.062 146.751.115z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.998 154.152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#151247",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-146.75-.115-.007 8.801L-.007 8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.93 241.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#151247",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-146.75-.115-.004 4.369 146.751.114z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath186)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.118 246.138)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-48.903-48.98.033-43.121h.106L43.226.033z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath202)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(424.196 154.048)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l21.671.021 91.989 92.134-21.67-.021z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath218)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(534.737 154.139)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l17.248 17.275-.025 32.686L-34.552-.021z"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M560.536 188.743h-163.89v18.092h163.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(417.093 182.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.102l12.138 27.767h14.102z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.164 182.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.102l12.139 27.767h14.101z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(477.236 182.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.102l12.138 27.767h14.102z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.309 182.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.102l12.138 27.767h14.102z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537.38 182.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-14.102l12.139 27.767h14.101z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.487 238.072)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-3.204-.123-1.875.595a2.038 2.038 0 01-2.306-.804l-.236-.351 9.366-5.173 1.812 3.884z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.235 232.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-9.439 5.214.33.598c.065.117.213.16.331.095L.448.811 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.044 236.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.474 4.282L0 8.702l-3.557-6.73z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.43 260.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-13.348 3.83-14.633.226c-1.285-3.603-9.072-19.548-9.072-19.548l5.812-3.032 8.717 15.141 11.73 1.02z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(395.58 233.213)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.613-1.665-1.928-.389a2.036 2.036 0 01-1.627-1.821l-.037-.421 10.7.017-.3 4.275z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400.116 228.863)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-10.784-.017-.001.683c0 .135.109.244.244.244l10.54.017L0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.774 233.209)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.342 7.174-4.262.48-.275-7.65z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.232 261.345)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-12.58-.573s-1.81-.099-1.689-4.335c.123-4.235.111-21.278.111-21.278l6.042-.209L-6.96-8.543l12.593.155c2.654.034 5.124 1.555 6.174 3.993.402.933.594 1.978.346 3.077z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(396.294 263.882)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1ad9d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.003-1.194-.807-1.375-2.001-1.377-1.193-.002-2.32.174-2.322 1.368A2.161 2.161 0 100 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.813 262.662)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1ad9d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.499-.005a1.19 1.19 0 00-1.189 1.184 1.19 1.19 0 001.185 1.189l2.498.005a1.19 1.19 0 001.189-1.184A1.19 1.19 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.716 262.408)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6f2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.833 4.089L9.438 5.208l2.054 12c.207 1.091 1.786 2.444 2.877 2.236l-.314.09c1.091-.207 2.092-1.474 1.885-2.565L13.941 2.613a2.01 2.01 0 00-1.5-1.578z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.233 281.588)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d7fd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.212-.017.42-.065.618-.142l.103-.041c1.763-.689 2.957-2.58 3.037-4.353L2.152-21.562c-10.642.093-12.153 1.318-12.153 1.318l.846 17.417c.129 1.643.883 3.188 2.754 3.344z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.514 262.543)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.082-1.191-.713-1.425-1.904-1.506-1.192-.082-2.327.019-2.408 1.21A2.16 2.16 0 100 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.11 261.427)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.493-.171A1.19 1.19 0 00-3.758.931a1.189 1.189 0 001.103 1.265l2.492.171a1.19 1.19 0 001.266-1.102A1.192 1.192 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.03 261.168)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d7fd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-1.103 4.024 11.193 1.8-.637 10.408c.135 1.102 1.343 2.341 2.444 2.206 1.103-.133 2.187-1.331 2.053-2.433l.806-12.471a2.011 2.011 0 00-1.391-1.675z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.664 274.995)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#091218",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l12.213-1.151a.855.855 0 00.768-.752l1.283-11.005a.856.856 0 00-.93-.95L.919-12.688a.857.857 0 00-.771.768L-.931-.934A.855.855 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(387.96 275.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1b2934",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l12.213-1.151a.855.855 0 00.768-.752l1.282-11.006a.854.854 0 00-.929-.949L.918-12.688a.856.856 0 00-.77.768L-.931-.934A.855.855 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.589 262.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#091218",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l8.344-.787a.464.464 0 00-.086-.921l-8.849.802z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(394.96 268.385)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.337 1.337 0 10-2.663.253A1.337 1.337 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(417.095 274.999)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6f2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.275-7.825-10.442-1.982 9.202 2.874z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.557 282.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.697-1.873a1.835 1.835 0 011.596-1.19c1.366-.092 2.349 1.29 1.812 2.549L2.881 2.364z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.178 280.958)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e16c5f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s3.439.65 2.934 3.657c-.505 3.007-3.74.661-3.74.661l.316-3.002z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.872 289.956)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.394 5.394 0 012.603-7.172A5.396 5.396 0 110 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath364)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.76 286.607)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.85-4.322 2.327-4.416c3.177-.095 1.447 8.107 1.447 8.107L-1.253 8.75l-7.693-1.893.763-4.974s1.224-.65 7.837.44z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.621 289.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.526-3.696 2.179 2.407z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(412.911 287.61)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.525 1.525 0 112.764-1.29A1.525 1.525 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(405.823 288.571)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-1.166 4.252 1.591 6.885c2.273 2.17 5.991 2.03 8.009-.381.948-1.131 1.71-2.835 1.78-5.397z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.41 288.643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f1ab00",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.28,
    d: "M0 0l-.033 2.654a1.25 1.25 0 002.493.141L2.726.146"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(417.203 289.678)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.121,
    d: "M0 0l-12.381-1.188"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(529.922 146.224)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.775-2.688-3.163-1.703-2.711 2.656z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510.387 166.308)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l1.854-8.207a13.06 13.06 0 012.113-4.67l12.208-10.968 4.828 3.934L10.579-8.874 6.761 5.682z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(529.441 141.911)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-1-3.19-1.143-1.589a2.03 2.03 0 01.047-2.43l.259-.332 7.79 7.258-3.114 2.914z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(535.473 141.606)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-7.851-7.314-.628.673L-.629.675z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.228 141.231)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-1.041-3.477-3.575.959L-3.571.896z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.022 175.463)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-10.014-33.85 6.319-1.577 5.636 16.969L8.866-7.355c.352.495.697 1.014.989 1.55a6.556 6.556 0 01.792 3.235l-.024 2.202z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(498.82 139.048)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-3.16-1.167-1.971-.067a2.044 2.044 0 01-1.907-1.535l-.106-.41L3.439-4.92l.407 4.277z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(502.29 134.052)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14103d",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-10.666 1.755.15.916L.151.917z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.045 209.844)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334fbe",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-4.047-6.314 1.94-1.393 4.188 6.682z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.79 220.309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4265d1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s1.87-7.827 11.347-10.908a.748.748 0 00.519-.604c.121-.906.122-2.865-1.973-3.446a.752.752 0 00-.593.095C7.851-13.956.722-9.788-6.198-10.99z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.79 220.309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#334fbe",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-1.737-7.808-6.198-10.99c0 0 .629 6.844 6.198 10.99"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(488.679 203.94)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.293-1.437.89-3.189 2.326-3.483a2.654 2.654 0 013.133 2.069c.294 1.436-.89 3.19-2.326 3.483A2.654 2.654 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.283 199.722)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.807 2.932L-4.639.677 0-2.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(495.837 202.433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6f2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.966-4.409 8.11-7.423a4.239 4.239 0 011.524-.147l10.707 1.387a3.059 3.059 0 012.91 3.2c-.08 1.688.243 4.129-1.443 4.049L6.401-5.897z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.85 192.315)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d7fd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c.286 2.339-.775 4.654-2.76 5.926-.891.571-1.775.957-2.412.848-2.136-.36-4.331-1.328-5.271-4.211-1.598-4.902-2.055-19.393-2.055-19.393l11.478-.391z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.614 191.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c6f2",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l3.451-12.683.697 10.76z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(529.682 166.924)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.085.987 1.164 3.101.178 4.186a2.654 2.654 0 01-3.75.177c-1.086-.986-1.165-3.099-.179-4.184A2.656 2.656 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(524.474 175.958)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.093-5.164 2.81.739-1.738 5.483"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(524.607 171.974)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d8d7fd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l5.747 1.264L1.85 14.595a4.256 4.256 0 01-.688 1.368l-7.156 8.908c-.967 1.385-2.597 1.138-3.983.171a3.06 3.06 0 01-.757-4.259l6.891-8.286z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(511.991 200.834)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l.218-2.01a1.855 1.855 0 113.679.485l-.483 3.126z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512.186 199.044)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e16c5f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s3.545.116 3.799 3.189C4.052 6.263.285 4.434.285 4.434l-.438-3.021z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(509.225 209.185)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a5.457 5.457 0 118.445-6.913A5.457 5.457 0 010 0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(515.144 204.189)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-1.909-4.025 1.182-4.909C4.271-5.793 4.62 2.678 4.62 2.678L.951 8.889l-8.013.06-.491-5.066s1.038-.942 7.792-1.52z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(512.908 208.285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l1.557-4.253 2.735 1.817z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(514.56 205.383)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb8175",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.544 1.544 0 012.388-1.955A1.543 1.543 0 010 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.82 207.622)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-.268 4.451 3.01 6.481c2.703 1.674 6.352.759 7.847-2.046.703-1.318 1.101-3.164.636-5.713z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(508.413 207.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f1ab00",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 0.283,
    d: "M0 0l.521 2.635a1.264 1.264 0 002.498-.382l-.29-2.677"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.313 206.344)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.133,
    d: "M0 0l-12.501 1.406"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 173.99)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 187.616)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 201.242)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 214.868)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 228.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 242.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 255.746)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 269.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 282.998)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 296.624)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 310.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l-12.935-12.751"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 174.865)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 188.491)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 202.117)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 215.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 229.37)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 242.995)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 256.621)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 270.247)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 283.873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 297.499)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h12.935"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.678 157.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5571e9",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v150.523"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.612 157.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5571e9",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v150.523"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M601.768 134.478H576.01v26.762h25.758z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.648 308.07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3d5ac4",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-13.463a4.3 4.3 0 00-4.301 4.301v16.886a4.3 4.3 0 004.301 4.3H0a4.3 4.3 0 004.301-4.3V4.301A4.301 4.301 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.56 315.488)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2f4dab",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h-8.665v11.924H0c1.8 0 3.259-1.459 3.259-3.258V3.259C3.259 1.459 1.8 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(497.344 306.68)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231c61",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.162,
    d: "M0 0l10.347-30.057"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.147 310.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231c61",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.162,
    d: "M0 0l-20.177-27.252"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.172 296.878)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l20.85-27.264a6.839 6.839 0 00-1.279-9.586L-7.693-57.699a6.838 6.838 0 00-9.585 1.278l-20.85 27.264a6.838 6.838 0 001.278 9.586L-9.585 1.278A6.837 6.837 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.602 291.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231c61",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.114,
    d: "M0 0l17.059-22.308a5.594 5.594 0 00-1.046-7.842L-6.295-47.208a5.594 5.594 0 00-7.843 1.045l-17.058 22.308a5.594 5.594 0 001.046 7.842L-7.843 1.046A5.595 5.595 0 000 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(491.944 281.108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.411-17.014-5.165.689C-6.812-10.601-6.178-5.038-5.41.721zm-2.643-22.614c-.539-4.049-6.682-3.23-6.142.819.545 4.084 6.687 3.265 6.142-.819"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.042 312.796)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231c61",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a8.65 8.65 0 10-17.3 0A8.65 8.65 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(500.508 312.796)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373482",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a6.116 6.116 0 10-12.231 0A6.116 6.116 0 000 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528.312 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(511.87 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.7 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(562.908 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(579.894 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(597.505 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.804 351.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(511.013 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.299 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528.312 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.298 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(545.61 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.299 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(562.908 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.298 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(580.206 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.299 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(597.505 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0l17.299 18.335"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.392 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5571e9",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0h141.038l-18.99 18.335H14.59z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.392 333.558)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5571e9",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 2.649,
    d: "M0 0v-20.762"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.827 136.955)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l9.872 25.516c.471 1.215 2.192 1.215 2.663 0L22.407 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    clipPath: "url(#clipPath726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.643 151.569h-17.528v5.415h17.528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.982 141.334h-19.826v5.416h19.826z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath738)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8c400",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M444.152 134.805h-26.13v2.15h26.13z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.184 136.876)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d100",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l9.873 25.516c.471 1.216 2.191 1.216 2.662 0L22.408 0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    clipPath: "url(#clipPath752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583 151.49h-17.529v5.415H583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.339 141.256h-19.825v5.415h19.825z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.14893 0 0 2.14893 -652.964 -287.87)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath764)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8c400",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M587.509 134.726H561.38v2.15h26.129z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(386.707 179.602)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5571e9",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0-11.323-9.179-20.503-20.502-20.503-11.323 0-20.502 9.18-20.502 20.503 0 11.322 9.179 20.502 20.502 20.502C-9.179 20.502 0 11.322 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.205 186.91)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.137,
    d: "M0 0v-52.105"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.232 185.849)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.137,
    d: "M0 0l7.973-8.941"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.277 177.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.137,
    d: "M0 0c-.571-.57-7.072-7.34-7.072-7.34"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.494 134.303)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3d5ac4",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 1,
    strokeWidth: 1.137,
    d: "M0 0h343.901"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/underConstruction.5bfbb68ee67b79ca2d203e6c79a073a5.svg";
export { ForwardRef as ReactComponent };